import gql from 'graphql-tag'

export const scanningFields = gql`
  query ScanningFields($accountId: Int!, $token: String, $userId: Int) {
    scanningFields(accountId: $accountId, token: $token, userId: $userId) {
      fields
      entities
    }
  }
`
